import React, { useState, useRef, useEffect } from "react";

export function NumericInput({
  value,
  onChangeRaw,
  onBlurNumber,
  decimals = 3,
  disabled = false,
  className,
  placeholder,
}) {
  const ref = useRef(null);
  const [text, setText] = useState(
    value === undefined || value === null ? "" : String(value).replace(".", ",")
  );

  useEffect(() => {
    setText(value === undefined || value === null ? "" : String(value).replace(".", ","));
  }, [value]);

  const normalizeToDot = (s) => (s ? s.replace(",", ".").replace(/\s/g, "") : "");

  const handleChange = (e) => {
    const filtered = e.target.value.replace(/[^\d,.-]/g, "");
    setText(filtered);
    if (onChangeRaw) onChangeRaw(normalizeToDot(filtered));
  };

  const handleBlur = () => {
    const parsed = parseFloat(normalizeToDot(text));
    const number = Number.isFinite(parsed) ? parsed : 0;
    const display = number.toLocaleString("pt-BR", {
      minimumFractionDigits: 0,
      maximumFractionDigits: decimals,
    });
    setText(display);
    if (onBlurNumber) onBlurNumber(number);
  };

  return (
    <input
      ref={ref}
      type="text"
      inputMode="decimal"
      value={text}
      onChange={handleChange}
      onBlur={handleBlur}
      disabled={disabled}
      className={className}
      placeholder={placeholder}
    />
  );
}
